import {
  formatPercentageValue,
  createKpiTileItem,
} from '../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { assignedAlertsPercentage, assignedAlertsPercentageDelta = 0 } =
      data || {};

    return createKpiTileItem(
      'Assigned Alerts',
      formatPercentageValue(assignedAlertsPercentage),
      Number(assignedAlertsPercentageDelta) !== 0
        ? {
            isPositiveValue: assignedAlertsPercentageDelta >= 0,
            text: formatPercentageValue(
              Math.abs(assignedAlertsPercentageDelta)
            ),
            sideLabel: '',
          }
        : null
    );
  },
};
